import React, { useState, useEffect } from 'react';

export default function CopyRight(props) {
    const { title } = props;
    return title
    // return <div className='layout-h center' style={{
    //     textAlign: 'center',
    //     ...props.style
    // }}>
    //     <div className='fill' style={{
    //         borderBottom: '1px solid',
    //         borderImage: "linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1)) 1 1"
    //     }}></div>
    //     <div style={{
    //         padding: "0 15px"
    //     }}>
    //         {title}
    //     </div>
    //     <div className='fill' style={{
    //         borderBottom: '1px solid',
    //         borderImage: "linear-gradient(90deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1"
    //     }}></div>
    // </div>
}